module.exports = __webpack_public_path__ + "img/Rooms_text01a_tableCD.ee37722a.png";